import styles from './CtaToast.module.css'
export function CtaToast() {
    return <>
        <div className={`${styles.ctaToastBox} ctaForm`}>
            <div className={`${styles.ctaContent} ctaForm`}>
                <p className={styles.slogan}>Do you like these ideas? <span>Bring them to life in your new home!</span></p>
                <button className={`btn font12`} >Get Quote</button>
            </div>
        </div>
    </>
}